import { render } from "./vitals.vue?vue&type=template&id=a238e3a0&scoped=true"
import script from "./vitals.vue?vue&type=script&lang=js"
export * from "./vitals.vue?vue&type=script&lang=js"

import "./vitals.vue?vue&type=style&index=0&id=a238e3a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a238e3a0"]])

export default __exports__